<template>
    <v-container
        class="scroll-updater-main-container"
        >
        <v-row
            v-scroll="scrollTopOverDetect"
            >
            <!-- Datepicker -->
            <v-col
                cols="5"
                sm="5"
                md="5"
                >
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateFormated"
                            :label="dataPickerTitle"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        no-title
                        scrollable
                        locale="pt-br"
                        :type="dataPickerType"
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="changeDatepickerType()"
                            >
                            {{ this.dataPickerChangeTypeTxBtn }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                            >
                            Sair
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="updateAll(date)"
                            >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col><!-- Datepicker -->
            <!-- Estação -->
            <v-col
                cols="6"
                sm="4"
                md="4"
                >
                <v-select
                    v-model="id"
                    :items="devices"
                    item-text="title"
                    item-value="id"
                    label="Estação"
                    @change="updateAll()"
                    ></v-select>
            </v-col><!-- Estação -->
        </v-row>

        <!-- Medições Entregues ao DAEE -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCard1
                    route="sideccr/getDeliveryToDaee"
                    um="%"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="Medições Entregues ao DAEE"
                    desc="Medições Entregues ao DAEE"
                    :update="update"
                    ></DashboardDaeeCard1>
            </v-col>
        </v-row><!-- Medições Entregues ao DAEE -->

        <!-- VOLUME HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCard2
                    route="sideccr/hourlyBulkGetedInLimit"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="VOLUME HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO"
                    desc="VOLUME HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO"
                    :update="update"
                    ></DashboardDaeeCard2>
            </v-col>
        </v-row><!-- VOLUME HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO -->

        <!-- HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCard2
                    route="sideccr/hourlyGetedInLimit"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO"
                    desc="HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO"
                    :update="update"
                    ></DashboardDaeeCard2>
            </v-col>
        </v-row><!-- HORARIO CAPTADO DENTRO DO LIMITE PERMITIDO -->

        <!-- Disponibilidade do sistema SiDeCC-R -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCard1
                    route="sideccr/dispWs"
                    um="%"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="Disponibilidade do sistema SiDeCC-R"
                    desc="Disponibilidade do sistema SiDeCC-R"
                    icon="mdi-sync"
                    :update="update"
                    ></DashboardDaeeCard1>
            </v-col>
        </v-row><!-- Disponibilidade do sistema SiDeCC-R -->

        <!-- Disponibilidade da Rede Elétrica -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCard1
                    route="sideccr/dispElNet"
                    um="%"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="Disponibilidade da Rede Elétrica"
                    desc="Disponibilidade da Rede Elétrica"
                    icon="mdi-sync"
                    :update="update"
                    ></DashboardDaeeCard1>
            </v-col>
        </v-row><!-- Disponibilidade da Rede Elétrica -->

        <!-- Disponibilidade da Conectividade -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCard1
                    route="sideccr/dispCon"
                    um="%"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="Disponibilidade da Conectividade"
                    desc="Disponibilidade da Conectividade"
                    icon="mdi-sync"
                    :update="update"
                    ></DashboardDaeeCard1>
            </v-col>
        </v-row><!-- Disponibilidade da Conectividade -->

        <!-- Disponibilidade da Operadora  -->
        <v-row>
            <v-col
                cols="12"
                sm="6"
                md="4"
                >
                <DashboardDaeeCardSignal
                    route="sideccr/dispSignal"
                    :id="id"
                    :dateStart="dateStart"
                    :dateEnd="dateEnd"
                    title="Disponibilidade da Operadora"
                    desc="Disponibilidade da Operadora"
                    :update="update"
                    ></DashboardDaeeCardSignal>
            </v-col>
        </v-row><!-- Disponibilidade da Operadora  -->

    </v-container>
</template>
<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { functions } from "../functions";
    import { sort } from "fast-sort";
    import moment from 'moment';
    import DashboardDaeeCard1 from "./DashboardDaeeCard1";
    import DashboardDaeeCard2 from "./DashboardDaeeCard2";
    import DashboardDaeeCardSignal from "./DashboardDaeeCardSignal";
    import { scrollUpdater } from "../mixins/scrollUpdater";
    import { appCaller } from "../mixins/appCaller";
    import { dateTimeTools } from "../mixins/dateTimeTools.js";

    export default {

        name: "DashboardDaee",
        components: {
            DashboardDaeeCard1,
            DashboardDaeeCard2,
            DashboardDaeeCardSignal
        },

        mixins: [scrollUpdater, appCaller, dateTimeTools],

        props: {
            msg: String
        },

        data: function () {
            return {
                rootApi: process.env.VUE_APP_ROOT_API,
                dataPickerType: "date",
                dataPickerChangeTypeTxBtn: "Mudar para Mês",
                dataPickerTitle: "Dia",
                date: this.dateNow(),
                menu: false,
                modal: false,
                from: null,
                to: null,
                month: null,
                year: null,
                dateStart: null,
                dateEnd: null,
                id: 1,
                devices: [],
                update: 0
            };
        },

        created: function () {

            EventBus.$emit("eventPageLoad", {
                name: "Dashboard Daee"
            });

            this.sideccrParamsRequest();
        },

        mounted: function () {
            //Ação do usuário que dispara evento de atualização.
            EventBus.$on("scrollTopOverDetect", function () {
                this.appCallerDispatchEventByLevel(this.$updNowLevels.level1);
            }.bind(this));

            //Atualiza informações da tela quando evento for disparado.
            this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {
                this.updateAll();
            }.bind(this));
        },

        computed: {
            dateFormated() {
                return moment(this.date).format('DD-MM-YYYY');
            }
        },

        afterCreate: function () {

        },

        beforeCreate: function () {

        },

        beforeDestroy: function () {
        },

        methods: {

            changeDatepickerType() {
                this.dataPickerType = this.dataPickerType == "date" ? "month" : "date";
                this.dataPickerChangeTypeTxBtn = this.dataPickerType == "date" ? "Mudar para mês" : "Mudar para dia";
                this.dataPickerTitle = this.dataPickerType == "date" ? "Dia" : "Mês";
            },

            parseDateToUrl(date) {
                return date.replaceAll("/", "-");
            },

            parseDateToUpdate(date) {
                this.dateStart = this.dateStart ? this.dateStart : this.dateTimeNow();
                this.dateEnd = this.dateEnd ? this.dateEnd : this.dateTimeNow();

                if (date) {
                    this.$refs.menu.save(date);
                    const dt = new Date(date.substr(0, 10));
                    this.date = dt.toISOString().substr(0, 10);
                    this.dateStart = this.date;
                    this.dateEnd = this.date;
                }

                if (this.dataPickerType === "month") {
                    const dt = new Date(this.dateStart);
                    const y = dt.getFullYear();
                    const m = dt.getMonth() + 1;
                    const lastDay = new Date(y, m + 1, 0);
                    this.dateEnd = lastDay.toISOString().substr(0, 10);
                }

                console.log(this.dateStart, this.dateEnd);
            },

            updateAll(date = null) {
                this.parseDateToUpdate(date);
                this.menu = false;
                this.update++;
            },

            sideccrParamsParseResponse(response) {
                this.devices = response.list;
            },

            sideccrParamsRequest() {

                EventBus.$emit("eventWaitingStart", {opacity: 0});

                const url = `${this.rootApi}/sideccr/sideccrParamGetAll`;
                axios
                        .get(url, axios.getHeaders())
                        .then((response) => {
                            this.sideccrParamsParseResponse(response.data);
                        })
                        .catch((err) => {
                            return functions.parseCatch(err, this.$appMessages.err404);
                        })
                        .finally(() => {
                            EventBus.$emit("eventWaitingEnd");
                        });
            }
        }
    };
</script>

<style>

</style>
